import Phaser from 'phaser';

export const ATLAS_KEY = 'game_atlas';

// Cached set of atlas frame names (populated on first call)
let _atlasFrames: Set<string> | null = null;

/** Get the set of all atlas frame names. Cached after first call. */
export function getAtlasFrames(scene: Phaser.Scene): Set<string> {
    if (_atlasFrames) return _atlasFrames;
    _atlasFrames = new Set();
    try {
        const atlas = scene.textures.get(ATLAS_KEY);
        if (atlas) {
            for (const name of atlas.getFrameNames()) {
                if (name !== '__BASE') _atlasFrames.add(name);
            }
        }
    } catch { /* atlas not loaded yet */ }
    return _atlasFrames;
}

/** Create an image using atlas frame or standalone texture. */
export function atlasCreateImage(scene: Phaser.Scene, x: number, y: number, key: string): Phaser.GameObjects.Image {
    if (getAtlasFrames(scene).has(key)) {
        return scene.add.image(x, y, ATLAS_KEY, key);
    }
    return scene.add.image(x, y, key);
}

/** Apply texture to existing sprite — routes to atlas or standalone. */
export function atlasApplyTexture(
    scene: Phaser.Scene,
    sprite: Phaser.GameObjects.Image | Phaser.GameObjects.Sprite,
    key: string,
): void {
    if (getAtlasFrames(scene).has(key)) {
        sprite.setTexture(ATLAS_KEY, key);
    } else {
        sprite.setTexture(key);
    }
}

/** Check if a key is an atlas frame. */
export function isAtlasFrame(scene: Phaser.Scene, key: string): boolean {
    return getAtlasFrames(scene).has(key);
}
